import { render, staticRenderFns } from "./EditGenealogy.vue?vue&type=template&id=0ed8eb42&scoped=true"
import script from "./EditGenealogy.vue?vue&type=script&lang=js"
export * from "./EditGenealogy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8eb42",
  null
  
)

export default component.exports